import car from '../../js/stores/car.js';
import contact from '../../js/stores/contact.js';
import carLoan from '../../js/stores/car-loan.js';
import carAppointments from '../../js/stores/car-appointment.js';
import carFeatureLibrary from '../../js/controllers/car-feature-lib.js';

const carLoanItemLibrary = {
  async getLoanData (carLoanId, item = {}) {
    let carLoanItem = (Object.keys(item).length === 0) ? await carLoan.dispatch('getItemById', carLoanId) : item;
    let carId = carLoanItem.CarId;

    let result = await car.dispatch('getCarData', carId);
    if (result.status !== undefined && result.status !== 200) {
      console.log(result.data.messages.error);
      return {};
    }

    let carItem = await this.loadCarItem(carId);

    const obj = {
      props: {}
    };

    obj.props = carItem.props;
    obj.props.CarLoanData = this.fillCarLoanData(carLoanItem);

    let contactData = await contact.dispatch('getContactData', carLoanItem.BorrowerId);
    if (contactData.status !== undefined && contactData.status !== 200) {
      console.log(contactData.data.messages.error);
      contactData= {};
    }
    let contactAddressData = await contact.dispatch('getContactAddress', carLoanItem.BorrowerId);
    if (contactAddressData.status !== undefined && contactAddressData.status !== 200) {
      console.log(contactAddressData.data.messages.error);
      contactAddressData = {};
    }
    contactData = { ...contactData, ...contactAddressData };

    obj.props.DriverData = this.fillDriverData(contactData);

    contactData = await contact.dispatch('getContactData', carLoanItem.ExtraDriverContactId);
    if (contactData.status !== undefined && contactData.status !== 200) {
      console.log(contactData.data.messages.error);
    }
    contactAddressData = await contact.dispatch('getContactAddress', carLoanItem.ExtraDriverContactId);
    if (contactAddressData.status !== undefined && contactAddressData.status !== 200) {
      console.log(contactAddressData.data.messages.error);
    }
    contactData = { ...contactData, ...contactAddressData };

    obj.props.ExtraDriverData = this.fillDriverData(contactData);

    let appointmentData = await carAppointments.dispatch('getLoanAppointmentItemToDeliver', carLoanId);
    if (appointmentData.status !== undefined && appointmentData.status !== 200) {
      console.log(appointmentData.data.messages.error);
      appointmentData = { CarAppointmentId: 0 };
    }
    obj.props.AppointmentData = this.fillAppointmentData(appointmentData);

    let returnAppointmentData = await carAppointments.dispatch('getLoanAppointmentItemToReturn', carLoanId);
    if (returnAppointmentData.status !== undefined && returnAppointmentData.status !== 200) {
      console.log(returnAppointmentData.data.messages.error);
      returnAppointmentData = { CarAppointmentId: 0 };
    }
    obj.props.ReturnAppointmentData = this.fillAppointmentData(returnAppointmentData);

    return obj;
  },

  async hasOwnership (loanId) {
    let result = {
      logMessage: 'User has permission',
      value: 1,
      isOwner: false,
      isBorrower: false,
    }

    const contactData = await contact.dispatch('getSelfData');
    if (contactData.status !== undefined && contactData.status !== 200) {
      result.logMessage = 'User not found';
      result.value = -1;
      result.route = "/";
    }

    const carLoanItem = await carLoan.dispatch('getItemOwnership', loanId);
    if (carLoanItem.status !== undefined && carLoanItem.status !== 200) {
      result.logMessage = 'Loan not valid';
      result.value = -2;
      result.route = "/";
    }

    result.isOwner = (Number(contactData.ContactId) == Number(carLoanItem.LenderId)) ? true : false;
    result.isBorrower = (Number(contactData.ContactId)  == Number(carLoanItem.BorrowerId)) ? true : false;

    if ( !(result.isOwner || result.isBorrower)){
      result.logMessage = 'User not involved in this loan';
      result.value = 0;
      result.route = "/forbidden/";
    }

    return result;
  },

  async loadCarItem (carId) {
    let carItem = {};
    let result = await car.dispatch('getCarData', carId);
    if (result.status !== undefined && result.status !== 200) {
      console.log(result.data.messages.error);
      return {};
    }

    carItem.CarMainData = result;
    carItem.CarFeatureList = await carFeatureLibrary.getLocalizedData(carId, 1);
    carItem.CarUseRestrictionList = await carFeatureLibrary.getLocalizedData(carId, 2);
    carItem.CarPenaltyUseList = await carFeatureLibrary.getLocalizedData(carId, 3);

    const obj = {
      props: carItem
    };

    return obj;
  },

  fillCarLoanData (carLoanItem) {
    return {
      CarLoanId: carLoanItem.CarLoanId,
      CarLoanTag: carLoanItem.CarLoanTag,
      BorrowerId: carLoanItem.BorrowerId,
      CarPricePerDay: carLoanItem.CarPricePerDay,
      DaysToBorrow: carLoanItem.DaysToBorrow,
      TotalToPay: carLoanItem.TotalToPay,
      Discounts: carLoanItem.Discounts,
      IsGoingAbroad: carLoanItem.IsGoingAbroad,
      CarLoanStartDate: carLoanItem.CarLoanStartDate,
      CarLoanEndDate: carLoanItem.CarLoanEndDate,
      CarLoanStartTime: carLoanItem.CarLoanStartTime,
      CarLoanEndTime: carLoanItem.CarLoanEndTime,
      CarLoanStatusId: carLoanItem.CarLoanStatusId,
      InvoiceId: carLoanItem.InvoiceId,
      CurrentKilometers: carLoanItem.CurrentKilometers,
      CurrentFuelLevel: carLoanItem.CurrentFuelLevel,
      ReturningKilometers: carLoanItem.ReturningKilometers,
      ReturningFuelLevel: carLoanItem.ReturningFuelLevel,
      CarLicensePlate: carLoanItem.CarLicensePlate,
      CarLoanTag: carLoanItem.CarLoanTag,
      ExtraDriverContactId: carLoanItem.ExtraDriverContactId,
      AppointmentDate: carLoanItem.AppointmentDate,
      AppointmentPlace: carLoanItem.AppointmentPlace,
      ReturnAppointmentDate: carLoanItem.ReturnAppointmentDate,
      ReturnAppointmentPlace: carLoanItem.ReturnAppointmentPlace,
      RealCarLoanStartDate: carLoanItem.RealCarLoanStartDate,
      RealCarLoanEndDate: carLoanItem.RealCarLoanEndDate,
    }
  },

  fillDriverData (driverData) {
    const contactId = Number(driverData.ContactId);
    return {
      ContactId: (contactId > 0) ? driverData.ContactId : 0,
      ContactName: (contactId > 0) ? driverData.ContactName : '',
      ContactFirstLastName: (contactId > 0) ? driverData.ContactFirstLastName : '',
      ContactSex: (contactId > 0) ? driverData.ContactSex : 0,
      ContactBirthDate: (contactId > 0) ? driverData.ContactBirthDate : null,
      ContactAddress: (contactId > 0) ? driverData.ContactAddress : '',
      ContactAddressStreet: (contactId > 0) ? driverData.ContactAddressStreet : '',
      ContactAddressExteriorNumber: (contactId > 0) ? driverData.ContactAddressExteriorNumber : 0,
      ContactDistrict: (contactId > 0) ? driverData.ContactDistrict : '',
      ContactZipcode: (contactId > 0) ? driverData.ContactZipcode : '',
      ContactCellphone: (contactId > 0) ? driverData.ContactCellphone : '',
      ContactEmail: (contactId > 0) ? driverData.ContactEmail : '',
      ContactLocalityName: (contactId > 0) ? driverData.ContactLocalityName : '',
    };
  },

  fillAppointmentData (data) {
    const appointmentId = parseInt(data.CarAppointmentId, 10);
    return {
      CarAppointmentId: (appointmentId > 0) ? data.CarAppointmentId : 0,
      CarAppointmentDate: (appointmentId > 0) ? data.CarAppointmentDate : null,
      CarAppointmentAddress: (appointmentId > 0) ? data.CarAppointmentAddress : '',
      CarAppointmentLatitude: (appointmentId > 0) ? data.CarAppointmentLatitude : 0.00,
      CarAppointmentLongitude: (appointmentId > 0) ? data.CarAppointmentLongitude : 0.00,
    };
  },

};

export default carLoanItemLibrary;
